import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench, faVolleyball, faPlus, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import config from '../../config/default.json';
import { useUtil } from '../Util';

const base_url = config.base_url;

const Profile = () => {
  const [tournaments, setTournaments] = useState([]);
  const [userId, setUserId] = useState(null); // assuming JWT contains user ID
  const navigate = useNavigate();
  const { formatDateWithSlashesNoTimezone } = useUtil();
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {
    name: 'Guest'
  };


  // Decode JWT from localStorage (or from context/auth hook)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUserId(payload.id); // adjust depending on your token structure
    } catch (err) {
      console.error('Invalid token');
    }
  }, []);

 const fetchTournaments = async () => {
  try {
  
    const token = localStorage.getItem('token'); // or use your own token storage key
    const response = await fetch(base_url + '/api/admin/tournaments/', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      alert('Network error');
      return;
    }

    const data = await response.json();
      const sortedTournaments = data.sort(
        (a, b) => new Date(b.startdate) - new Date(a.startdate)
      );
    setTournaments(sortedTournaments);
  } catch (error) {
    console.error('Error fetching tournaments:', error);
  }
};


  useEffect(() => {
    fetchTournaments();
  }, []);



  const handleCreateTournament = () => {
    navigate('/auth/add-tournament');
  };

  const handleLogout = () => {
    // Remove token
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // Optionally clear other cached admin checks
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('admin_check_')) {
        localStorage.removeItem(key);
      }
    });

    // Redirect to login page or homepage
    navigate('/auth/login');
  };


  return (
    <div className="Profile">
      <br />
      <button onClick={handleLogout} className="header-button">
         <FontAwesomeIcon icon={faUserSlash} /> &nbsp; LogOut
      </button>
      <br />
      <br />
      <h1>Profile Page </h1>
      <br />
     <p>Welcome to your Profile </p> <h2> {user.name}</h2> 
      <p> You can now create new or manage Tournamnets</p>
      <br />
      <div style={{ textAlign: 'center', margin: '10px 0' }}>
        <button className="header-button" onClick={handleCreateTournament}>
          <FontAwesomeIcon icon={faPlus} /> Create New Tournament
        </button>
      </div>

      <div className="card-container">
        {tournaments.map((tournament) => {
          const isOwner = tournament.owner === userId;
          return (
          <Link to={`/admin/${tournament.linkindex}/admin`} className="select-button">
            <div key={tournament._id} className="tournament-card">
              <table>
                <tbody>
                  <tr>
                    <td colSpan="2" style={{ fontWeight: 'bold', color: 'purple', fontSize: '20px', textAlign: 'center' }}>
                      {tournament.name}
                    </td>
                  </tr>
                  <tr style={{ color: 'black' }}>
                    <td>Date: {formatDateWithSlashesNoTimezone(tournament.startdate)}</td>
                    <td>Location: {tournament.location}</td>
                  </tr>
                   <tr>
                    <td>Published: </td>
                    <td style={{ fontWeight: 'bold', color: 'purple', fontSize: '18px' }}>
                      {tournament.isPublished.toString().charAt(0).toUpperCase() + tournament.isPublished.toString().slice(1)}                     
                    </td>
                  </tr>
                  {/* <tr>
                    <td>Winner:</td>
                    <td style={{ fontWeight: 'bold', color: 'purple', fontSize: '18px' }}>
                      {tournament.winner?.name || 'TBD'}{' '}
                      {tournament.winner?.name && <FontAwesomeIcon icon={faTrophy} />}
                    </td>
                  </tr> */}
                  <tr>
                    <td colSpan="2" style={{ textAlign: 'center' }}>
                      <Link to={`/admin/${tournament.linkindex}/admin`} className="select-button">
                        <FontAwesomeIcon icon={faVolleyball} /> &nbsp;{tournament.acronym} &nbsp; <FontAwesomeIcon icon={faVolleyball} />
                      </Link>
                    </td>
                  </tr>
                  {isOwner && (
                    <tr>
                      <td colSpan="2" style={{ textAlign: 'center' }}>
                        <Link to={`/admin/${tournament.linkindex}/admin`} className="manage-button">
                          <FontAwesomeIcon icon={faScrewdriverWrench} /> &nbsp;  Manage
                        </Link>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Profile;
